<template>
  <div>
    <b-card v-if="!plan" no-body class="mb-0">
      <div class="loading_page">
        <orbit-spinner :animation-duration="1000" :size="100" :color="'#0e96b1'" />
      </div>
    </b-card>
    <b-card v-else no-body class="mb-0">
      <div class="loading_page" v-if="indicator">
        <orbit-spinner :animation-duration="1000" :size="100" :color="'#0e96b1'" />
      </div>
      <div class="m-2">
        <washer-plan-form :form="form" :errors="errors" :rows="rows" :indicator.sync="indicator" @submit="handleSubmit"></washer-plan-form>
      </div>
    </b-card>
  </div>
</template>

<script>

import {
  BCard, BRow, BCol
} from 'bootstrap-vue'
import { OrbitSpinner } from 'epic-spinners'
import flatPickr from 'vue-flatpickr-component'
import Ripple from "vue-ripple-directive"
import WasherPlanForm from '@/views/modules/plans/washer-plan/share/WasherPlanForm.vue'
import { useWasherPlanForm } from '@/views/modules/plans/washer-plan/composable/useWasherPlanForm'
import { useWasherPlanApi } from '@/views/modules/plans/washer-plan/composable/useWasherPlanApi'
import { onMounted, ref } from '@vue/composition-api'
import router from '@/router'


export default {
  components: {
    BRow, BCol, BCard,
    OrbitSpinner,
    flatPickr,
    WasherPlanForm
  },
  directives: {
    Ripple,
  },

  setup(props, { root }) {

    const errors = ref({})
    const indicator = ref(false)

    const { form, rows, buildFormData, initiate_form } = useWasherPlanForm()
    const { update, getPlan } = useWasherPlanApi()

    const id = router.currentRoute.params.id
    const plan = ref(null)

    onMounted(() => {
      console.log('mounted ...')
      indicator.value = true
      getPlan(id).then(r => {
        plan.value = r.data.plan
        initiate_form(r.data.plan)
      }).finally(_ => indicator.value = false)
    })

    const handleSubmit = async () => {
      indicator.value = true
      const formData = buildFormData()
      update(formData, plan.value.id).then(r => {
        console.log('Done!')
        console.log(r.data)
        root.$bvToast.toast(root.$t('Washer plan updated successfully'), {
          title: root.$t("success"),
          variant: 'success',
          solid: false,
        })
      }).catch(e => {
        errors.value = e.response.data.errors
        console.log(errors.value)
        root.$bvToast.toast(root.$t("did not update the plan!"), {
          title: root.$t("Error"),
          variant: 'danger',
          solid: false,
        })
      }).finally(_ => indicator.value = false)
    }

    return {
      plan,
      indicator,
      form,
      errors,
      rows,
      handleSubmit,
    }
  }

}
</script>

<style lang="scss">
@import '@core/scss/vue/libs/vue-select.scss';
</style>
